export const iconFontAwesomeMarketingShrimp = (
	<i className="fa-solid fa-shrimp"></i>
);
